<template>
  <div class="main">
    <div class="query-item">
      <div class="search-l">
        <div>
          <a-input class="inp ml24" placeholder="请输入动态标题" v-model:value="query.title"></a-input>
        </div>

        <a-select v-model:value="query.status" placeholder="请选择状态" class="ml30 status-select">
          <a-select-option value=''>全部</a-select-option>
          <a-select-option value='1'>已发布</a-select-option>
          <a-select-option value='0'>草稿</a-select-option>
          <a-select-option value='2'>已下架</a-select-option>
        </a-select>

        <a-select v-model:value="query.type" placeholder="请选择分类" class="ml30 type-select">
          <a-select-option value=''>全部</a-select-option>
          <a-select-option value='1'>通知公告</a-select-option>
          <a-select-option value='2'>活动动态</a-select-option>
          <a-select-option value='3'>政策法规</a-select-option>
          <a-select-option value='4'>产业报告</a-select-option>
        </a-select>

        <a-button class="ml30" @click="search" type="primary" ghost>查询</a-button>
        <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
      </div>
      <div class="search-r">
        <a-button class="ml30" @click="add" type="primary">+ 新建</a-button>
        <a-button class="ml30" type="primary" @click="router.push('/home/manage')"><i class="iconfont icon-fanhuiicon mr5"></i> 返回</a-button>
      </div>
    </div>

    <!-- 工作动态列表 - 使用Table实现 -->
    <a-table
        :columns="columns"
        :row-key="(record) => record.id"
        :data-source="dataSource"
        class="mt23"
        size="middle"
        :pagination="pagination"
        :scroll="{ y: 'auto' }"
        v-autoHeight="{ extraHeight: 88, trHeight: 47 }"
    >
      <template #bodyCell="{ column, record, index }">
        <!-- 注意这里增加了 index 参数 -->
        <template v-if="column.key === 'index'">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
        <template v-if="column.key === 'type'">
          <span class="type-tag" :class="getTypeClass(record ? record.type : '')">{{ getTypeText(record ? record.type : '') }}</span>
        </template>
        <template v-if="column.key === 'coverImg'">
          <img v-if="record && record.coverImg" :src="record.coverImg" alt="封面图片" class="cover-image" />
          <span v-else class="no-cover">无封面</span>
        </template>
        <template v-if="column.key === 'title'">
          <span class="news-title" @click="viewNews(record)">{{ record ? record.title : '' }}</span>
        </template>
        <template v-if="column.key === 'publishDate'">
          {{ formatDate(record ? record.publishDate : '') }}
        </template>
        <template v-if="column.key === 'status'">
          <span class="status-tag" :class="getStatusClass(record ? record.status : '')">{{ getStatusText(record ? record.status : '') }}</span>
        </template>
        <template v-if="column.key === 'action'">
          <span v-if="record">
            <a @click="editNews(record)">修改</a>
            <a v-if="record.status === 0 || record.status === 2" class="ml10" @click="publishNews(record.id)">发布</a>
            <a v-else-if="record.status === 1" class="ml10" @click="disableNews(record.id)">下架</a>
            <a class="ml10" @click="delNews(record)">删除</a>
          </span>
        </template>
      </template>
    </a-table>
    <!-- 统一工作动态弹框 -->
    <a-modal
        v-model:open="modalVisible"
        :title="isEditMode ? '编辑工作动态' : '新增工作动态'"
        width="800px"
        @ok="handleModalSubmit"
        @cancel="handleModalCancel"
    >
      <a-form :model="formData" layout="vertical" :rules="formRules" ref="formRef">
        <a-form-item label="标题" name="title">
          <a-input v-model:value="formData.title" placeholder="请输入工作动态标题" />
        </a-form-item>
        <a-form-item label="分类" name="type">
          <a-select v-model:value="formData.type" placeholder="请选择分类">
            <a-select-option value="1">通知公告</a-select-option>
            <a-select-option value="2">活动动态</a-select-option>
            <a-select-option value="3">政策法规</a-select-option>
            <a-select-option value="4">产业报告</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="封面图片" name="coverImg">
          <ImageUploader
              :box-height="150"
              :box-width="220"
              v-model:imageUrl="formData.coverImg"
              :path-name="'news'" />
        </a-form-item>
        <a-form-item label="链接地址" name="linkUrl">
          <a-input v-model:value="formData.linkUrl" placeholder="请输入链接地址" />
        </a-form-item>
        <a-form-item label="排序" name="sort">
          <a-input v-model:value="formData.sort"/>
        </a-form-item>
        <a-form-item label="状态" name="status">
          <a-select v-model:value="formData.status" placeholder="请选择状态">
            <a-select-option value="0">草稿</a-select-option>
            <a-select-option value="1">发布</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script setup>
import { ref, onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import { message, Modal } from 'ant-design-vue'
import { getPagesByCondition, updateStatus, del, add as addNewsApi, update } from "@/api/news/index.js";
import ImageUploader from '@/components/imageUploader/index.vue'

const router = useRouter();

// 统一弹框显示/隐藏状态变量
const modalVisible = ref(false);
// 标识当前是新增还是编辑模式
const isEditMode = ref(false);

// 统一表单引用
const formRef = ref();

// 统一表单数据模型
const formData = reactive({
  id: '',
  title: '',
  type: '',
  coverImg: '',
  content: '',
  linkUrl: '',
  status: '0'
});

// 表单验证规则
const formRules = {
  title: [
    { required: true, message: '请输入工作动态标题', trigger: 'blur' },
    { min: 2, max: 100, message: '标题长度在 2 到 100 个字符', trigger: 'blur' }
  ],
  type: [
    { required: true, message: '请选择分类', trigger: 'change' }
  ],
  content: [
    { required: true, message: '请输入工作动态内容', trigger: 'blur' },
    { min: 10, message: '内容长度不能少于 10 个字符', trigger: 'blur' }
  ],
  status: [
    { required: true, message: '请选择状态', trigger: 'change' }
  ]
};

let dataSource = ref([]);
let query = reactive({
  title: '',
  status: null,
  type: null
});

// 表格列定义
const columns = [
  {
    title: "序号",
    dataIndex: "index",
    key: "index",
    fixed: 'left',
    width: 50
  },
  {
    title: "分类",
    dataIndex: "type",
    key: "type",
    ellipsis: true,
    width: 100
  },
  {
    title: "封面",
    dataIndex: "coverImg",
    key: "coverImg",
    ellipsis: true,
    width: 120
  },
  {
    title: "动态标题",
    dataIndex: "title",
    key: "title",
    ellipsis: true,
    width: 270
  },
  {
    title: "发布时间",
    dataIndex: "publishDate",
    key: "publishDate",
    width: 100
  },
  {
    title: "状态",
    dataIndex: "status",
    key: "status",
    width: 60
  },
  {
    title: "操作",
    key: "action",
    fixed: 'right',
    width: 140
  },
];

const pageChange = (page) => {
  pagination.current = page;
  getData();
}

const pageSizeChange = (current, size) => {
  pagination.pageSize = size;
  getData();
}

const pagination = reactive({
  total: 0,
  size: "middle",
  defaultPageSize: 10,
  current: 1,
  pageSize: 10,
  showSizeChanger: true,
  showQuickJumper: false,
  pageSizeOptions: ["10", "20", "30"],
  showTotal: (total) => `共有 ${total} 条数据`,
  onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize), // 改变每页数量时更新显示
  onChange: pageChange, //点击页码事件
  showSizeChange: pageSizeChange,
});

const search = () => {
  pagination.current = 1;
  getData();
};

  const reset = () => {
    query.title = '';
    query.status = null;
    query.type = null;
    pagination.current = 1;
    getData();
  };

  const getData = () => {
    let data = {
      pageIndex: pagination.current,
      pageSize: pagination.pageSize,
      conditionMap: { ...query },
    };
    // 过滤为空的字段
    for (let key in data) {
      if (data[key] === null || data[key] === undefined || data[key] === '') {
        delete data[key];
      }
    }
    getPagesByCondition(data).then(res => {
      if (res.code === 200) {
        dataSource.value = res.data.records || [];
        pagination.total = res.data.total;
      }
    });
  }

  // 页面初始化时获取数据
  onMounted(() => {
    getData();
  });

// 格式化日期
const formatDate = (dateString) =>{
  if (!dateString) return '';
  return dateString;
}

// 获取状态文本
const getStatusText = (status) => {
  const statusMap = {
    0: '草稿',
    1: '已发布',
    2: '已下架'
  };
  return statusMap[status] || '未知状态';
}

// 获取状态样式类
const getStatusClass = (status) => {
  const statusClassMap = {
    0: 'status-draft',
    1: 'status-published',
    2: 'status-disabled'
  };
  return statusClassMap[status] || '';
}

// 获取分类文本
const getTypeText = (type) => {
  const typeMap = {
    0: '未知类型',
    1: '通知公告',
    2: '活动动态',
    3: '政策法规',
    4: '产业报告'
  };
  return typeMap[Number(type)] || '未知类型';
}

// 获取分类样式类
const getTypeClass = (type) => {
  const typeClassMap = {
    1: 'type-notice',
    2: 'type-activity',
    3: 'type-policy',
    4: 'type-report'
  };
  return typeClassMap[Number(type)] || '';
}

// 查看详情
const viewNews = (record) => {
  if (record && record.linkUrl) {
    window.open(record.linkUrl, '_blank');
  }
};

// 打开新增工作动态弹框
const add = () => {
  // 设置为新增模式
  isEditMode.value = false;
  // 重置表单
  if (formRef.value) {
    formRef.value.resetFields();
  }
  // 重置表单数据
  Object.assign(formData, {
    id: '',
    title: '',
    type: '',
    coverImg: '',
    content: '',
    linkUrl: '',
    status: '0'
  });
  // 显示统一弹框
  modalVisible.value = true;
};

// 打开编辑工作动态弹框
const editNews = (item) => {
  if (!item) return;
  // 设置为编辑模式
  isEditMode.value = true;
  // 填充表单数据
  Object.assign(formData, {
    id: item.id || '',
    title: item.title || '',
    type: String(item.type || ''),
    coverImg: item.coverImg || '',
    content: item.content || '',
    linkUrl: item.linkUrl || '',
    status: String(item.status || '0')
  });
  // 显示统一弹框
  modalVisible.value = true;
};

// 统一弹框提交处理
const handleModalSubmit = async () => {
  try {

    await formRef.value.validate();
    const apiFn = isEditMode.value ? update : addNewsApi;
    const res = await apiFn(formData);
    if (res.code === 200) {
      message.success(isEditMode.value ? '工作动态编辑成功' : '工作动态新增成功');
      // 关闭统一弹框
      modalVisible.value = false;
      // 刷新数据列表
      getData();
    } else {
      message.error(res.message || (isEditMode.value ? '工作动态编辑失败' : '工作动态新增失败'));
    }
  } catch (error) {
    if (error.errorFields) {
      // 表单验证失败，不显示错误提示
      return;
    }
    message.error('操作失败，请重试');
    console.error((isEditMode.value ? '编辑' : '新增') + '工作动态出错:', error);
  }
};

// 统一弹框取消处理
const handleModalCancel = () => {
  // 关闭统一弹框
  modalVisible.value = false;
  // 重置表单
  if (formRef.value) {
    formRef.value.resetFields();
  }
};

// 删除
const delNews = async (item) => {
  try {
    const res = await del(item.id);

    if (res.code === 200) {
      message.success('工作动态删除成功');
      getData();
    } else {
      message.error(res.message || '工作动态删除失败');
    }
  } catch (error) {
    message.error('操作失败，请重试');
    console.error('删除工作动态出错:', error);
  }
};

// 发布工作动态
const publishNews = async (id) => {
  Modal.confirm({
    title: '确定要发布该工作动态吗？',
    content: '发布后，工作动态将对所有用户可见。',
    okText: '确定',
    okType: 'primary',
    cancelText: '取消',
    async onOk() {
      try {
        const data = {
          id: id,
          status: 1
        };
        const res = await updateStatus(data);
        if (res.code === 200) {
          message.success('工作动态发布成功');
          getData();
        } else {
          message.error(res.message || '工作动态发布失败');
        }
      } catch (error) {
        message.error('操作失败，请重试');
        console.error('发布工作动态出错:', error);
      }
    }
  });
}

// 下架工作动态
const disableNews = async (id) => {
  Modal.confirm({
    title: '确定要下架该工作动态吗？',
    content: '下架后，用户将无法在前台查看该工作动态。',
    okText: '确定',
    okType: 'primary',
    cancelText: '取消',
    async onOk() {
      try {
        const data = {
          id: id,
          status: 2
        };
        const res = await updateStatus(data);
        if (res.code === 200) {
          message.success('工作动态下架成功');
          getData();
        } else {
          message.error(res.message || '工作动态下架失败');
        }
      } catch (error) {
        message.error('操作失败，请重试');
        console.error('下架工作动态出错:', error);
      }
    }
  });
}

onMounted(async () => {
  getData();
});

</script>

<style lang="less" scoped>
.inp {
  width: 25vw;
}

.query-item {
  display: flex;
  justify-content: space-between;

  .search-l {
    display: flex;
  }

  .search-r {
    display: flex;
  }

  .status-select {
    width: 120px;
  }
}

.main {
  padding: 20px;
  height: calc(100vh - 70px - 57px);
  background-color: #ffffff;
  overflow: hidden;
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th,
.ant-table-wrapper .ant-table-thead>tr>td {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(10, 33, 46, 1);
  background-color: rgba(239, 240, 245, 1);
}

/deep/.ant-table-wrapper .ant-table-thead>tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before,
.ant-table-wrapper .ant-table-thead>tr>td:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  width: 0px;
}

/deep/.ant-table-wrapper .ant-table.ant-table-middle .ant-table-tbody>tr>td {
  height: 90px;
}

.status-tag {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;

  &.status-draft {
    background-color: #f5f5f5;
    color: #86909c;
  }

  &.status-published {
    background-color: #f0f9ff;
    color: #1890ff;
  }

  &.status-disabled {
    background-color: #fff2f0;
    color: #ff4d4f;
  }
}

.type-tag {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;

  &.type-notice {
    background-color: #e6f7ff;
    color: #1890ff;
  }

  &.type-activity {
    background-color: #f6ffed;
    color: #52c41a;
  }

  &.type-policy {
    background-color: #fffbe6;
    color: #faad14;
  }

  &.type-report {
    background-color: #f9f0ff;
    color: #722ed1;
  }
}

.news-title {
  color: #2c3e50;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}

.news-content {
  font-size: 14px;
  line-height: 1.6;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

a {
  color: #1E8EF2;
}

.cover-image {
  width: 120px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
}

.no-cover {
  display: inline-block;
  width: 120px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  background-color: #f0f0f0;
  color: #999;
  border-radius: 4px;
  font-size: 12px;
}
</style>